var _excluded = ["style", "isOpen", "getToggleButtonProps"],
    _excluded2 = ["style", "css", "onClick"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { BasicButton } from '@adsk/alloy-button';
import Icon from '@adsk/alloy-icon';
import theme from '@adsk/alloy-theme';

var ToggleButton = function ToggleButton(_ref) {
  var style = _ref.style,
      isOpen = _ref.isOpen,
      getToggleButtonProps = _ref.getToggleButtonProps,
      props = _objectWithoutProperties(_ref, _excluded);

  var _getToggleButtonProps = getToggleButtonProps(),
      _ignoredStyle = _getToggleButtonProps.style,
      _ignoredCss = _getToggleButtonProps.css,
      toggleOnClick = _getToggleButtonProps.onClick,
      toggleButtonProps = _objectWithoutProperties(_getToggleButtonProps, _excluded2);

  return /*#__PURE__*/React.createElement(BasicButton, _extends({
    "data-testid": 'ControlLabel__toggle',
    style: {
      padding: 0,
      height: 32
    }
  }, toggleButtonProps, {
    onClick: function onClick(e) {
      e.stopPropagation();
      toggleOnClick === null || toggleOnClick === void 0 ? void 0 : toggleOnClick(e);
    }
  }, props), /*#__PURE__*/React.createElement(Icon, {
    type: isOpen ? Icon.TYPES.CHEVRON_UP : Icon.TYPES.CHEVRON_DOWN,
    size: 24,
    color: theme.colors.charcoal700,
    style: style
  }));
};

export default ToggleButton;
//# sourceMappingURL=ToggleButton.js.map